export default "__VITE_ASSET__BETgqFrJ__"